module.exports = __webpack_public_path__ + "img/republic-of-macedonia.611e09fe.png";